import type { CSSProperties } from 'react';

export type NetSuiteSyncWizardProps = {
  open: boolean;
  onClose: () => void;
  contractId: string;
  customerId: string;
  isSynced: boolean;
  customerErpId?: string;
};

export type AddErpIdDialogState = {
  open: boolean;
  productId: string;
};

export const INITIAL_DIALOG_STATE: AddErpIdDialogState = {
  open: false,
  productId: '',
};

export const WIZARD_STEPS = {
  CUSTOMER_CONNECTION: 'customerConnection',
  PRODUCT_SELECTION: 'productSelection',
  SUBSIDIARY_AND_MEMO: 'subsidiaryAndMemo',
} as const;

export type WizardStep = (typeof WIZARD_STEPS)[keyof typeof WIZARD_STEPS];

export const DIALOG_LABEL = 'Sync contract to ERP sales order';
export const DIALOG_LABEL_DESCRIPTION = 'Sync contract items into your ERP as a new sales order';
export const DIALOG_CONTENT_STYLE: CSSProperties = { minWidth: '580px', paddingTop: '30px' };

